<!-- Ported from vendor-ref/mara/app/ui/src/components/nanome/WorkspaceToolModeBar.vue (selection modes Atom / Residue / Chain, Exit tool) -->
<script setup lang="ts">
import Button from 'primevue/button';
import { useLiteStore } from '@nanome-lite/state';
import { TOOL_MODES, TOOL_MODE_ORDER } from '@/data/viewer-tools';

const store = useLiteStore();
</script>

<template>
  <div class="flex items-center gap-1 bg-xr rd-full p-1">
    <Button
      v-for="mode in TOOL_MODE_ORDER"
      :key="mode"
      v-tooltip.top="TOOL_MODES[mode].label"
      :icon="TOOL_MODES[mode].icon"
      :severity="store.view.selectionMode === mode ? 'primary' : 'secondary'"
      :text="store.view.selectionMode !== mode"
      size="small"
      rounded
      @click="store.setSelectionMode(mode)"
    />
    <Button
      v-tooltip.top="'Exit tool'"
      icon="i-tabler-x"
      severity="secondary"
      size="small"
      rounded
      text
      @click="store.setTool('default')"
    />
  </div>
</template>
